import Page from '../content/page';

import Configuration from '../configuration/configuration';

import HotelDescription from '../hotel/hotel_description';
import HotelPage from '../hotel/hotel_page';
import HotelReviews from '../hotel/hotel_reviews';
import HotelRoomCategories from '../hotel/hotel_roomcategories';
import HotelFacilities from '../hotel/hotel_facilities';
import HotelImages from '../hotel/hotel_images';
import HotelImage from '../hotel/hotel_image';
import HotelListing from '../destination/hotel_listing';
import HotelMap from '../hotel/hotel_map';
import HotelTitle from '../hotel/hotel_title';
import DestinationPage from '../destination/destination_page';

import Text from '../content/text';
import CodeBlock from '../content/code_block';
import Image from '../content/image';
import Video from '../content/video';
import Section from '../content/section/section';
import Feed from '../content/feed/feed';
import Slider from '../content/slider/slider';
import Card from '../content/card/card';
import GoogleMap from '../content/maps/google_map';
import GoogleMapMarker from '../content/maps/google_map_marker';
import TeaserListing from '../content/block_listings/teaser_listing';

import ButtonWrapper from '../buttons/button_wrapper';
import ButtonLink from '../buttons/button_link';
import ButtonAnchorLink from '../buttons/button_anchor_link';
import ButtonSubmit from '../buttons/button_submit';
import ButtonOther from '../buttons/button_other';

import FormWrapper from '../forms/form_wrapper';
import FormRadiobuttonsWrapper from '../forms/form_radiobuttons_wrapper';
import FormInput from '../forms/form_input';
import FormCheckbox from '../forms/form_checkbox';
import FormTextarea from '../forms/form_textarea';
import FormRadiobutton from '../forms/form_radiobutton';
import FormSelector from '../forms/form_selector';
import FormSelectorOption from '../forms/form_selector_option';
import FormSalesManagoForms from '../forms/form_salesmanago_forms';

import Banner from '../content/banner';
import PageMenu from '../content/page_menu';
import ButtonBooking from '../buttons/button_booking';
import HotelTripadvisor from '../hotel/hotel_tripadvisor';
import Label from '../content/label';
import LabelGroup from '../content/label_group';
import DestinationMap from '../destination/destination_map';
import ActivityList from '../destination/activity_list';
import HotelLabels from '../hotel/hotel_labels';
import TextAccordeon from '../content/text_accordeon';
import Table from '../content/table';

import OpenHours from '../content/open_hours';
import Chart from '../content/chart/chart';
import CountDown from '../content/countdown/countdown';
import Webcam from '../content/webcam';
import Quiz from '../content/quiz/quiz';
import QuizResult from '../content/quiz/result';
import QuizQuestion from '../content/quiz/quiz_question';
import QuizAlternative from '../content/quiz/quiz_alternative';

const components = {
  page: Page,
  configuration: Configuration,
  destination_page: DestinationPage,
  hotel_page: HotelPage,
  hotel_description: HotelDescription,
  hotel_reviews: HotelReviews,
  hotel_roomcategories: HotelRoomCategories,
  hotel_facilities: HotelFacilities,
  hotel_images: HotelImages,
  hotel_image: HotelImage,
  hotel_listing: HotelListing,
  hotel_labels: HotelLabels,
  destination_map: DestinationMap,
  activity_list: ActivityList,
  hotel_tripadvisor: HotelTripadvisor,
  hotel_map: HotelMap,
  hotel_title: HotelTitle,
  text: Text,
  text_accordeon: TextAccordeon,
  code_block: CodeBlock,
  image: Image,
  video: Video,
  table: Table,
  button_wrapper: ButtonWrapper,
  button_link: ButtonLink,
  button_anchor_link: ButtonAnchorLink,
  button_submit: ButtonSubmit,
  button_other: ButtonOther,
  button_booking: ButtonBooking,
  slider: Slider,
  section: Section,
  card: Card,
  label: Label,
  label_group: LabelGroup,
  google_map: GoogleMap,
  google_map_marker: GoogleMapMarker,
  chart: Chart,
  teaser_listing: TeaserListing,
  feed: Feed,
  banner: Banner,
  countdown: CountDown,
  webcam: Webcam,
  form_wrapper: FormWrapper,
  form_radiobuttons_wrapper: FormRadiobuttonsWrapper,
  form_input: FormInput,
  form_checkbox: FormCheckbox,
  form_textarea: FormTextarea,
  form_radiobutton: FormRadiobutton,
  form_selector: FormSelector,
  form_selector_option: FormSelectorOption,
  form_salesmanago_forms: FormSalesManagoForms,
  page_menu: PageMenu,
  open_hours: OpenHours,
  quiz: Quiz,
  quiz_result: QuizResult,
  quiz_question: QuizQuestion,
  quiz_alternative: QuizAlternative,
};

export default components;
